/**
 * A factory that builds unique instances of a plugin given a
 * configuration object and options.
 *
 * Plugins are inherently stateful and full of side-effects,
 * so a new version of the plugin is created for each instance
 * of a Microcosm.
 */

"use strict";

exports.__esModule = true;
var NOOP = function NOOP() {};

function installPlugin(next, plugin) {
  return function (error) {
    return error != null ? next(error) : plugin.register(plugin.app, plugin.options, next);
  };
}

exports["default"] = function (plugins) {
  var callback = arguments.length <= 1 || arguments[1] === undefined ? NOOP : arguments[1];

  return plugins.reduceRight(installPlugin, callback)();
};

module.exports = exports["default"];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9pbnN0YWxsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQVNBLElBQU0sSUFBSSxHQUFHLFNBQVAsSUFBSSxHQUFTLEVBQUUsQ0FBQTs7QUFFckIsU0FBUyxhQUFhLENBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRTtBQUNwQyxTQUFPLFVBQVUsS0FBSyxFQUFFO0FBQ3RCLFdBQU8sS0FBSyxJQUFJLElBQUksR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsR0FBRyxFQUFFLE1BQU0sQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLENBQUE7R0FDdkYsQ0FBQTtDQUNGOztxQkFFYyxVQUFVLE9BQU8sRUFBaUI7TUFBZixRQUFRLHlEQUFDLElBQUk7O0FBQzdDLFNBQU8sT0FBTyxDQUFDLFdBQVcsQ0FBQyxhQUFhLEVBQUUsUUFBUSxDQUFDLEVBQUUsQ0FBQTtDQUN0RCIsImZpbGUiOiJzcmMvaW5zdGFsbC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQSBmYWN0b3J5IHRoYXQgYnVpbGRzIHVuaXF1ZSBpbnN0YW5jZXMgb2YgYSBwbHVnaW4gZ2l2ZW4gYVxuICogY29uZmlndXJhdGlvbiBvYmplY3QgYW5kIG9wdGlvbnMuXG4gKlxuICogUGx1Z2lucyBhcmUgaW5oZXJlbnRseSBzdGF0ZWZ1bCBhbmQgZnVsbCBvZiBzaWRlLWVmZmVjdHMsXG4gKiBzbyBhIG5ldyB2ZXJzaW9uIG9mIHRoZSBwbHVnaW4gaXMgY3JlYXRlZCBmb3IgZWFjaCBpbnN0YW5jZVxuICogb2YgYSBNaWNyb2Nvc20uXG4gKi9cblxuY29uc3QgTk9PUCA9ICgpID0+IHt9XG5cbmZ1bmN0aW9uIGluc3RhbGxQbHVnaW4gKG5leHQsIHBsdWdpbikge1xuICByZXR1cm4gZnVuY3Rpb24gKGVycm9yKSB7XG4gICAgcmV0dXJuIGVycm9yICE9IG51bGwgPyBuZXh0KGVycm9yKSA6IHBsdWdpbi5yZWdpc3RlcihwbHVnaW4uYXBwLCBwbHVnaW4ub3B0aW9ucywgbmV4dClcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiAocGx1Z2lucywgY2FsbGJhY2s9Tk9PUCkge1xuICByZXR1cm4gcGx1Z2lucy5yZWR1Y2VSaWdodChpbnN0YWxsUGx1Z2luLCBjYWxsYmFjaykoKVxufVxuIl19




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/install.js
 ** module id = 199
 ** module chunks = 0
 **/